export const CHANGE_TOKENS_ACTION = {
    name: 'CHANGE_TOKENS_ACTION',
    action: (accessToken, refreshToken) => ({
        accessToken, refreshToken,
        type: CHANGE_TOKENS_ACTION.name
    })
};

export const GO_TO_LOGOUT_ACTION = {
    name: 'GO_TO_LOGOUT_ACTION',
    action: error => ({
        error,
        type: GO_TO_LOGOUT_ACTION.name
    })
};

export const SESSION_EXPIRED_ACTION = {
    name: 'SESSION_EXPIRED_ACTION',
    action: () => ({
        type: SESSION_EXPIRED_ACTION.name
    })
};

export const LOGOUT_ACTION = {
    name: 'LOGOUT_ACTION',
    action: () => ({
        type: LOGOUT_ACTION.name
    })
};

export const LOGOUT_SUCCESS_ACTION = {
    name: 'LOGOUT_SUCCESS_ACTION',
    action: () => ({
        type: LOGOUT_SUCCESS_ACTION.name
    })
};

export const LOGIN_AND_REDIRECT_ACTION = {
    name: 'LOGIN_AND_REDIRECT_ACTION',
    action: pathToRedirect => ({
        pathToRedirect,
        type: LOGIN_AND_REDIRECT_ACTION.name
    })
};

export const SET_REDIRECT_URL_ACTION = {
    name: 'SET_REDIRECT_URL_ACTION',
    action: pathToRedirect => ({
        pathToRedirect,
        type: SET_REDIRECT_URL_ACTION.name
    })
};

export const SSO_GET_TOKEN_BY_CODE = {
    name: 'SSO_GET_TOKEN_BY_CODE',
    action: code => ({
        code,
        type: SSO_GET_TOKEN_BY_CODE.name
    })
};

export const SSO_GOT_TOKEN_BY_CODE = {
    name: 'SSO_GOT_TOKEN_BY_CODE',
    action: (accessToken, refreshToken) => ({
        accessToken,
        refreshToken,
        type: SSO_GOT_TOKEN_BY_CODE.name
    })
};
